<template>
    <div class="container">
        <!-- 轮播 -->
        <!--<van-swipe class='swiper' :autoplay="3000" :duration="1000" :style="{height:iHeight+'px'}">-->
        <van-swipe class='swiper' :autoplay="3000" :duration="1000">
            <van-swipe-item v-for='(item, index) in bannerList' :key='index'>
                <a :href='item.url' class="banner">
                    <img :src='item.img' class='slide-image'/>
                </a>
            </van-swipe-item>
        </van-swipe>

        <a class="top-search-box" style="background:rgba(255, 255, 255, 0.6)" href="/search">
            <i></i>
            <span>搜索竞赛</span>
        </a>

        <!-- nav -->
        <div class='nav-ul'>
            <a v-for='(item, index) in navList' :key='index' :href='item.url' :target="index==3?'_blank':''">
                <img :src="'/static/img/index-page/nav-'+(index+1)+'.png'">
                <span>{{ item.title }}</span>
            </a>
        </div>

        <!-- 竞赛圈轮播 -->
        <!--        <a class='cmpt-circle-swiper' href='/cmptCircle'>-->
        <!--            <div class='cmpt-circle-swiper-inner'>-->
        <!--                <div class='image-title'>-->
        <!--                    <img src='/static/img/index-page/circle-banner.png'>-->
        <!--                </div>-->
        <!--                <div class='circle-swiper'>-->
        <!--                    <van-swipe class='swiper' :vertical="true" :autoplay="3000" :duration="1000"-->
        <!--                               style="width: 100%;height: 100%">-->
        <!--                        <van-swipe-item v-for='(i, iIndex) in cmptCircleList' :key='iIndex'>-->
        <!--                            <div class="div">-->
        <!--                                <span class="a" v-for="(item, index) in i" :key='index'>{{item.title}}</span>-->
        <!--                            </div>-->
        <!--                        </van-swipe-item>-->
        <!--                        <div class="custom-indicator" slot="indicator"></div>-->
        <!--                    </van-swipe>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </a>-->

        <!-- 精选竞赛 -->
        <div v-if='competitionList.length != 0' class='chosen-cmpt'>
            <div class='chosen-cmpt-inner'>
                <div><span class='add-bor'></span>精选竞赛</div>
                <a href='/competition'>更多
                    <img src='/static/img/common/listArrow@2x.png'>
                </a>
            </div>
        </div>
        <div v-if='competitionList.length != 0' style='width: 100%;'>
            <!-- 当精选项目为空的时候 -->
            <div v-if='competitionList.length == 0' class='content-empty'>
                <div class='empty-pic'>
                    <img :src='ossAddr("/img/content-empty.png")'>
                </div>
                <span style='font-size: 28px;color: #BDC1C7;'>{{ $t('dc_lang.暂无内容') }}~</span>
            </div>
            <competitionItem @go-detail="gotoDetail" v-for="(item,index) in competitionList" :key="index"
                             :item="item" pageType="index" :index="index"></competitionItem>
        </div>

        <!-- 高阶挑战赛 -->
        <div v-if='seniorList.length != 0' class='chosen-cmpt'>
            <div class='chosen-cmpt-inner'>
                <div><span class='add-bor'></span>高阶挑战赛</div>
                <a href='/competition'>更多
                    <img src='/static/img/common/listArrow@2x.png'>
                </a>
            </div>
        </div>
        <div v-if='seniorList.length != 0' style='width: 100%;'>
            <!-- 高阶挑战赛为空的时候 -->
            <div v-if='seniorList.length == 0' class='content-empty'>
                <div class='empty-pic'>
                    <img :src='ossAddr("/img/content-empty.png")'>
                </div>
                <span style='font-size: 28px;color: #BDC1C7;'>{{ $t('dc_lang.暂无内容') }}~</span>
            </div>
            <competitionItem @go-detail="gotoDetail" v-for="(item,index) in seniorList" :key="index"
                             :item="item" pageType="index" :index="index"></competitionItem>
        </div>

        <!-- 新手训练赛 -->
        <div v-if='firstList.length != 0' class='chosen-cmpt'>
            <div class='chosen-cmpt-inner'>
                <div><span class='add-bor'></span>新手训练赛</div>
                <a href='/competition'>更多
                    <img src='/static/img/common/listArrow@2x.png'>
                </a>
            </div>
        </div>
        <div v-if='firstList.length != 0' style='width: 100%;'>
            <competitionItem @go-detail="gotoDetail" v-for="(item,index) in firstList" :key="index"
                             :item="item" pageType="index" :index="index"></competitionItem>
        </div>

        <!-- 当所有的竞赛都为空的时候,显示缺省页 -->
        <div
            v-if='seniorList.length==0&&firstList.length ==0&&competitionList.length==0&&requestBool1&&requestBool2&&requestBool3'
            style='width: 100%;'>
            <div class='content-empty'>
                <div class='empty-pic'>
                    <img :src='ossAddr("/img/content-empty.png")'>
                </div>
                <span style='font-size: 28px;color: #BDC1C7;'>{{ $t('dc_lang.暂无内容') }}~</span>
            </div>
        </div>

        <!--国际化按钮-->
        <div @click="changeLangEvent" class="changeLang">
            <div v-if="lang === 'zh-CN'">
                <img class="lang-icon" src="static/img/lang/international.png" alt="">
                <span>国际版(ENG)</span>
            </div>
            <div v-else>
                <img class="lang-icon" src="static/img/lang/internal.png" alt="">
                <span>国内版(CHN)</span>
            </div>
        </div>
    </div>
</template>

<script>
import alert from '@/components/common/alert/alert'
import CompetitionItem from '@/components/competition/competition-item/competition-item'
import api from '../../../api/api'
// import ShowLoading from '@/components/common/dc-loading/dc-loading'
export default {
    name: 'index',
    components: {
        CompetitionItem,
        // ShowLoading,
        alert
    },
    data () {
        return {
            lang: window.sessionStorage.getItem('lang') || 'zh-CN',
            ossAddr: this.common.ossAddr,
            bannerList: [],
            competitionList: [], // 精选竞赛
            firstList: [], // 新手训练赛
            seniorList: [], // 高阶挑战赛
            navList: [
                {
                    url: '/noviceRace',
                    title: '新手参赛'
                },
                {
                    url: '/enterprice',
                    title: '政企办赛'
                },
                // {
                //     url: '/ranking',
                //     title: '名人堂'
                // },
                {
                    url: 'https://www.dcxueyuan.com/courseCatalogue.html',
                    title: '进阶课程'
                }
            ],
            cmptCircleList: [],
            requestBool1: false,
            requestBool2: false,
            requestBool3: false,
            loadingStatus: false,
            bannerHeight: '',
            iHeight: 640
        }
    },
    mounted () {
        let me = this
        me.$parent.$refs.toastCompo.showLoading({
            msg: '加载中...'
        })
        me.iHeight = window.outerWidth * 0.41 * window.dpr
        me.getBanner()// banneer
        // me.getCmptCircle()// 竞赛圈
        me.getCmptList()// 精选竞赛
        // me.getfirstList()// 新手训练赛
        // me.getSeniorList()// 高阶挑战赛
    },
    methods: {
        changeLangEvent () {
            if (this.lang === 'zh-CN') {
                this.lang = 'en-US'
                this.$i18n.locale = this.lang// 关键语句
                window.sessionStorage.setItem('lang', this.lang)
            } else {
                this.lang = 'zh-CN'
                this.$i18n.locale = this.lang// 关键语句
                window.sessionStorage.setItem('lang', this.lang)
            }
            document.getElementsByTagName('title')[0].innerText = window.vm.$i18n.t('dc_lang.DC竞赛-大数据竞赛平台')
        },
        gotoDetail (data) {
            if(data.item.cmptType === '2'){
                if (data.item.ztsList[0].cmptHref) {
                            window.open(data.item.ztsList[0].cmptHref)
                        } else {
                            this.$router.push({path: '/cmptDetail.html', query: {id: data.item.ztsList[0].id}})
                        }
            }else{
                this.$router.push({path: '/cmptDetail.html', query: {id: data.id}})
            }

        },
        getBanner () { // 获取banner数据
            let me = this
            api.bannerUrl().then(res => {
                me.common.axiosSuccessFun({
                    this: me,
                    callBack () {
                        me.bannerList = res.data.data.bannerList
                    }
                }, res.data)
            }).catch((res) => {
                me.common.axiosFailFun({
                    this: me
                }, res)
            })
        },
        getCmptCircle () { // 竞赛圈
            let me = this
            api.topicIndexUrl({
                pageNo: 1,
                pageSize: 10
            }).then(res => {
                me.common.axiosSuccessFun({
                    this: me,
                    callBack () {
                        let topicList = res.data.data.topicList.list
                        let list = []
                        for (var i = 0; i < topicList.length; i++) {
                            if (i % 2 == 0) {
                                let arr = []
                                arr.push(topicList[i])
                                arr.push(topicList[i + 1])
                                list.push(arr)
                            }
                        }
                        me.cmptCircleList = list
                    }
                }, res.data)
            }).catch((res) => {
                me.common.axiosFailFun({
                    this: me
                }, res)
            })
        },
        getCmptList () { // 精选列表
            let me = this
            api.getCmptListES({
                keword: '',
                orderType: '',
                type: '',
                state: '',
                page: 1,
                pageSize: 10
            }).then((res) => {
                me.common.axiosSuccessFun({
                    this: me,
                    callBack () {
                        console.log(res);
                        me.competitionList = res.data.data.map.list
                        me.competitionList = me.competitionList.map((item) => {
                            if (item.rewardType === '奖金' && !(Number.isNaN(Number(item.reward.charAt(0))))) {
                                item.reward = '￥' + item.reward
                            }
                            return item;
                        });
                        me.requestBool1 = true;
                    }
                }, res.data);
            }).catch((res) => {
                me.common.axiosFailFun({
                    this: me
                }, res)
            })
        },
        getfirstList () { // 新手训练赛
            let me = this
            api.getDCWXAppIndexCmptListUrl({
                type: '新手训练赛'
            }).then(res => {
                me.common.axiosSuccessFun({
                    this: me,
                    callBack () {
                        me.firstList = res.data.data.list
                        me.firstList = me.firstList.map((item) => {
                            if (item.reward_type == '奖金' && !(Number.isNaN(Number(item.reward.charAt(0))))) {
                                item.reward = '￥' + item.reward
                            }
                            return item
                        })
                        me.requestBool2 = true
                    }
                }, res.data)
            }).catch((res) => {
                me.common.axiosFailFun({
                    this: me
                }, res)
            })
        },
        getSeniorList () { // 高阶挑战赛
            let me = this
            api.getDCWXAppIndexCmptListUrl({
                type: '高阶挑战赛'
            }).then(res => {
                me.common.axiosSuccessFun({
                    this: me,
                    callBack () {
                        me.seniorList = res.data.data.list
                        me.seniorList = me.seniorList.map((item) => {
                            if (item.reward_type == '奖金' && !(Number.isNaN(Number(item.reward.charAt(0))))) {
                                item.reward = '￥' + item.reward
                            }
                            return item
                        })
                        me.requestBool3 = true
                    }
                }, res.data)
            }).catch((res) => {
                me.common.axiosFailFun({
                    this: me
                }, res)
            })
        }
    }
}
</script>

<style scoped lang="scss">
.container {
    position: relative;
    background: #f7f8f8;
    padding-bottom: 98px;
}

.changeLang {
    width: 100%;
    text-align: center;
    height: 120px;
    line-height: 120px;
    background-color: #F7F8F8;
    z-index: 99;

    .lang-icon {
        width: 36px;
        height: 36px;
        vertical-align: middle;
        margin-right: 10px;
    }

    span {
        font-size: 28px;
        color: #BDC1C7;
        vertical-align: middle;
    }
}

/* 轮播 */
.swiper {
    width: 100%;
    height: 320px;
    display: block;
}

.swiper img {
    height: 100%;
    width: 100%;
}

.top-search-box {
    position: absolute;
    padding-top: 0;
    top: 30px;
    width: 468px;
    display: block;
    left: 50%;
    margin-left: -235px;
    z-index: 1;
    height: 58px;
    line-height: 57px;
    color: #a7a7a7;
    border-radius: 26px;

    border: none;
}

.top-search-box i {
    float: left;
    margin: 14px 12px 0 26px;
    width: 30px;
    height: 30px;
    background: url('../../../../static/img/index-page/search.png') no-repeat 0 0;
    background-size: cover;
}

.top-search-box span {
    color: #fff;
    float: left;
    font-size: 30px /*px*/
}

/* nav */
.nav-ul {
    margin-top: -5px;
    width: 100%;
    height: 190px;
    background: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    justify-content: space-around;
    z-index: 99;
}

.nav-ul a {
    min-width: 112px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

.nav-ul img {
    width: 90px;
    margin: 30px auto 10px;
}

.nav-ul span {
    font-size: 28px;
    white-space: nowrap;
    word-break: keep-all;
    color: #17181A;
    text-align: center;
}

/* 竞赛圈轮播 */
.cmpt-circle-swiper {
    height: 130px;
    background: #fff;
    padding: 0 30px;
    display: block;;
    /*width: 100%;*/
}

.cmpt-circle-swiper-inner {
    display: flex;
    width: 100%;
    height: 100%;
    border-top: 2px solid #E9E9E9;
    justify-content: flex-start;
    align-items: center;
}

.cmpt-circle-swiper-inner .image-title {
    width: 126px;
    height: 26px;
    border-right: 2px solid #E9E9E9;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.cmpt-circle-swiper-inner .image-title img {
    width: 96px;
}

.cmpt-circle-swiper-inner div.circle-swiper {
    flex: 1;
    height: 130px;
    width: 100%;
    display: flex;
    overflow: hidden;
}

.circle-swiper .div {
    padding: 20px 0 20px 30px;
    box-sizing: border-box;
}

.circle-swiper .a {
    width: 100%;
    font-size: 28px; /*px*/
    color: #797C80;
    box-sizing: border-box;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 46px;
    white-space: nowrap;
}

/* 精选竞赛 */
.chosen-cmpt {
    /*width: 100%;*/
    height: 90px;
    padding: 0 30px;
}

.chosen-cmpt-inner {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.chosen-cmpt-inner div {
    font-size: 36px; /*px*/
    font-weight: bold;
    color: #17181A;
    // width: 200px;
    text-align: center;
    /* border-left: 6px solid #4DA6FF; */
    height: 34px;
    line-height: 34px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.chosen-cmpt-inner .add-bor {
    display: inline-block;
    width: 6px;
    height: 34px;
    background: #4DA6FF;
    border-radius: 2px;
    margin-right: 10px;
}

.chosen-cmpt-inner a {
    font-size: 28px; /*px*/
    color: #BDC1C7;
    width: 82px; /*px*/
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.chosen-cmpt-inner a img {
    width: 18px;
}

/* 精选竞赛为空 */
.content-empty {
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
}

.list-body:last-child {
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index/index.vue